import { useTranslation } from '@cobliteam/i18n';
import type React from 'react';
import { ControlButton } from '../ControlButton/ControlButton';
import * as styles from './styles';

export type MapType = 'roadmap' | 'hybrid';

export interface MapTypeControlProps {
  currentType: MapType;
  onTypeChange: (type: MapType) => void;
}

export const MapTypeControl: React.FC<MapTypeControlProps> = ({ onTypeChange, currentType }) => {
  const { t } = useTranslation('map');
  const isRoadType = currentType === 'roadmap';

  const handleTypeChange = (type: MapType) => () => {
    onTypeChange(type);
  };

  return (
    <div className={styles.mapTypeControl}>
      <ControlButton className='px-2.5 py-1' textClassName='!font-semibold' onClick={handleTypeChange('roadmap')} text={t('mapType.roadmap')} selected={isRoadType} />
      <ControlButton className='ml-1 px-2.5 py-1' textClassName='!font-semibold' onClick={handleTypeChange('hybrid')} text={t('mapType.satellite')} selected={!isRoadType} />
    </div>
  );
};
